/* DialogContext, used by the Exploration page component tree to maintain current UI selections
 */
import { createContext, useState } from 'react';

const DialogContext = createContext({});

// initializing dialog state
const dialogStateInit = {
    // dialog state (replicated in lessons context (for now for lessons admin mode)
    showDeleteConfirm: false,
    onDeleteConfirmed: null,
    deletingNodeDescr: '',
    showAlert: false,
    alertMessage: '',
    hideOK: false,
    showBackupDialog: false,
};

let alertDelayTimer = null;

// Establishes DialogContext via a custom use-hook.
//  returns as the context value and object containing the selection state and several useful updater functions
export function useDialogContext() {
    const [dialogState, setDialogState] = useState(dialogStateInit);

    const updateDialogState = (update) => {
        setDialogState((prev) => ({ ...prev, ...update }));
    };

    const setShowDeleteConfirm = (show) => updateDialogState({ showDeleteConfirm:  show });

    const setShowAlert = (show, message, delay, hideOK) => {
        console.log('editor setShowAlert -', show, message, delay );
        if (show) {
            if (delay) {
                if (!alertDelayTimer) {
                    alertDelayTimer = setTimeout(() => updateDialogState({ showAlert: true, alertMessage: message, hideOK: hideOK }), delay);
                } else {
                    updateDialogState({ alertMessage: message });
                }
            } else {
                updateDialogState({ showAlert: true, alertMessage: message, hideOK: hideOK })
            }
        } else {
            if (alertDelayTimer)
                clearTimeout(alertDelayTimer);
            alertDelayTimer = null;
            updateDialogState({ showAlert: false, alertMessage: '', hideOK: false });
        }
    };

    // DialogContext value
    return {
        ...dialogState,
        update: updateDialogState,
        clear: () => setDialogState(dialogStateInit),
        setShowDeleteConfirm,
        setShowAlert,
    };
}

export default DialogContext;
